import styled from '@emotion/styled';

/*
 * The step pads itself on every surface. The dialog hands its own padding over
 * for this step, and the mobile menu supplies none of its own, so one rule here
 * covers both.
 */
const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-top: -0.5rem;

  ${({ theme }) => theme.mq('lg')} {
    margin-top: 0;
    padding: 0 2rem 2rem;
  }
`;

const IllustrationWrapper = styled.figure`
  margin: 0.5rem 0;
  text-align: center;

  img {
    width: auto;
    height: 138px;
  }
`;

/* The question the step asks, so it carries more weight than the greeting. */
const OptionsHeadline = styled.h4`
  margin-block: 0 1rem;
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1.25;
  color: ${({ theme }) => theme.colors.neutral.grey160};
  text-align: center;
`;

/* Both providers and the email option share one height, as the funnel does. */
const Providers = styled.div`
  display: grid;
  gap: 0.5rem;

  > * {
    min-height: 3.5rem;
  }
`;

export { IllustrationWrapper, Options, OptionsHeadline, Providers };
